import { render, staticRenderFns } from "./regulations.vue?vue&type=template&id=3b917093"
import script from "./regulations.vue?vue&type=script&lang=js"
export * from "./regulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports